





































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "commitResetBar",
})
export default class CommitResetBar extends Vue {
    @Prop({ required: true })
    isDirty: boolean;

    @Prop({ default: false })
    disabled: boolean;

    @Prop({ required: true })
    commit: () => any;

    @Prop({ required: false })
    revert: () => any;

    hasCommitted: boolean = false;
    hasReverted: boolean = false;

    async doCommit() {
        await this.commit();
        this.hasCommitted = true;
        await new Promise((r) => setTimeout(r, 3000));
        this.hasCommitted = false;
    }

    async doRevert() {
        await this.revert();
        this.hasReverted = true;
        await new Promise((r) => setTimeout(r, 3000));
        this.hasReverted = false;
    }
}
